export default __webpack_public_path__ + "static/media/Feedback.66ee34d2.svg";